import axios, { type AxiosError } from 'axios';

function flattenMessage(data: unknown, depth = 0): string {
  if (depth > 3 || data == null) return '';
  if (typeof data === 'string') {
    try {
      return flattenMessage(JSON.parse(data), depth + 1);
    } catch {
      return data;
    }
  }
  if (typeof data === 'object') {
    const message = (data as Record<string, unknown>).message;
    if (typeof message === 'string') return message;
  }
  return '';
}

export function isWafBlockedError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  const ae = error as AxiosError;
  const status = ae.response?.status;

  if (status !== 403 && status !== 429) return false;

  const message = flattenMessage(ae.response?.data).toLowerCase();

  return (
    message.includes('too many requests') ||
    message.includes('temporarily blocked') ||
    message.includes('blocked for security')
  );
}
